<script>
    export default {
        props: {
            selected: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                region: this.selected
            }
        },

        watch: {
            'region': function(region) {
                let domainParts = window.location.hostname.split('.');

                domainParts.splice(1, 1, region);

                window.location = 'https://'+domainParts.join('.')+'/'+window.location.search;
            }
        }
    };
</script>
